// extracted by mini-css-extract-plugin
module.exports = {"google_login_button":"styles_google_login_button__E8W46","google_logo_icon":"styles_google_logo_icon__1z2HX"};